import { TokenLogout } from "API/Logout/logout"
import axios from "axios"


const url=process.env.REACT_APP_BACKEND_URL


export const GetAecsList =async(filter,page,setData,setIsloading)=>{
    try{
        setIsloading(true)
        await axios.post(`${url}/products/aec_admin/nseit/list`,{...filter},{
            headers:{
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            },
            params:{
                page:page,
                limit:10
            }
        })
        .then((res)=>{
            setData(res.data)
            setIsloading(false)
        })
        .catch((error)=>{
            setData(null)
            setIsloading(false)
            TokenLogout(error)
        })
    }
    catch(error){
        setData(null)
        setIsloading(false)
        TokenLogout(error)
    }
}

export const EditUserData=async(PostData,setPostData,userId,setIsloading,handleAlertOpen,GetData,setSelected,getList)=>{
    try{
        const formdata= new FormData()

        for(let key in PostData){
            formdata.append(key,PostData[key])
        }

        formdata.append("user_id",userId)
        setIsloading(true)
        await axios.post(`${url}/products/aec_admin/nseit/update`,formdata,{
            headers:{
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            }
        })
        .then((res)=>{
            
            
            handleAlertOpen(res.data.message,"success")
            setTimeout(()=>{
                setIsloading(false)
                setPostData({})
                GetData()
                getList()
                setSelected(null)
            },1500)
            
        })
    }
    catch(error){
        setIsloading(false)
        handleAlertOpen(error&&error.response?error.response.data.error:"Something went wrong !!!","error")
        TokenLogout(error)
    }
}